module.exports = __webpack_public_path__ + "img/doc-crop-before.c2280614.png";